var $9a7dcb914b29cd9f$exports = {};
$9a7dcb914b29cd9f$exports = {
  "close": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F");
      }
    }), ".");
  }
};
export { $9a7dcb914b29cd9f$exports as default };